import { render } from "./GMVStats.vue?vue&type=template&id=05b94f50&scoped=true"
import script from "./GMVStats.vue?vue&type=script&lang=js"
export * from "./GMVStats.vue?vue&type=script&lang=js"

import "./GMVStats.vue?vue&type=style&index=0&id=05b94f50&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b94f50"]])

export default __exports__